import React from "react";
import { MapPin, Mail } from "lucide-react";
import portfolio from "../data/portfolio.json";

const { personalInfo } = portfolio;

const About = () => {
  return (
    <section id="about" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 grid-bg-dense opacity-50" />
      <div className="max-w-7xl mx-auto px-6 relative">
        <div className="flex items-center gap-4 mb-16">
          <span className="font-mono text-xs text-teal-300">01 / About</span>
          <div className="h-px flex-1 bg-gradient-to-r from-zinc-800 to-transparent" />
        </div>

        <div className="grid lg:grid-cols-12 gap-12 items-start">
          {/* Portrait */}
          <div className="lg:col-span-5">
            <div className="relative group">
              <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-teal-300/20 via-transparent to-amber-300/10 blur-2xl opacity-60 group-hover:opacity-100 transition" />
              <div className="relative rounded-3xl overflow-hidden border border-zinc-800 bg-zinc-900">
                <img
                  src={personalInfo.portrait}
                  alt={personalInfo.name}
                  className="w-full aspect-[4/5] object-cover saturate-[0.55] group-hover:saturate-100 transition-all duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-transparent to-transparent" />
                <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
                  <div className="glass rounded-xl px-3 py-2">
                    <div className="text-[10px] font-mono text-zinc-500">
                      Currently
                    </div>
                    <div className="text-sm text-white">At Eleven Systems</div>
                  </div>
                  <span className="w-3 h-3 rounded-full bg-teal-300 shadow-[0_0_12px_rgba(94,234,212,0.8)] animate-pulse" />
                </div>
              </div>

            </div>
          </div>

          {/* Text */}
          <div className="lg:col-span-7 lg:pl-8">
            <h2
              className="font-display font-bold text-white tracking-tight"
              style={{ fontSize: "clamp(2rem, 5vw, 3.5rem)" }}
            >
              I like building things that{" "}
              <span className="text-teal-300">hold up in real use</span>.
            </h2>

            <div className="mt-8 space-y-5 text-zinc-400 leading-relaxed text-base md:text-lg">
              <p>{personalInfo.bio}</p>
              <p>{personalInfo.bio2}</p>
            </div>

            <div className="mt-10 grid grid-cols-2 gap-3">
              <div className="glass rounded-2xl p-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-zinc-900 border border-zinc-800 flex items-center justify-center">
                  <MapPin className="w-4 h-4 text-teal-300" />
                </div>
                <div>
                  <div className="text-[10px] text-zinc-500 font-mono uppercase">
                    Based in
                  </div>
                  <div className="text-sm text-white">{personalInfo.location}</div>
                </div>
              </div>
              <div className="glass rounded-2xl p-4 flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-zinc-900 border border-zinc-800 flex items-center justify-center">
                  <Mail className="w-4 h-4 text-teal-300" />
                </div>
                <div className="min-w-0">
                  <div className="text-[10px] text-zinc-500 font-mono uppercase">
                    Email
                  </div>
                  <div className="text-sm text-white truncate">
                    {personalInfo.email}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
